import alert from 'public/images/modal/alert.svg';
import info from 'public/images/modal/check.svg';
import coupon from 'public/images/modal/coupon.svg';
import login from 'public/images/modal/log-in.svg';
import questionnaire from 'public/images/modal/questionnaire.svg';
import warning from 'public/images/modal/warning.svg';
import { NextImage } from 'src/components/shared/elements/NextImage';

export const iconType = {
  INFO: 'info',
  WARNING: 'warning',
  LOGIN: 'login',
  QUESTIONNAIRE: 'questionnaire',
  ALERT: 'alert',
  COUPON: 'coupon',
} as const;

export type IconType = (typeof iconType)[keyof typeof iconType];

const images = { info, warning, login, questionnaire, alert, coupon } as const;

export const ModalIcon = ({ type = iconType.INFO }: { type?: IconType }) => (
  <NextImage src={images[type]} alt={type} width={36} height={36} />
);
